// Compact, static phone-shaped UI cards used in the For-the-team-lead section
// of the homepage. Pure presentation, mirrors the slices in /screenshots.html.

export function BrowsePreview() {
  return (
    <div className="pp-phone pp-dark">
      <div className="pp-body">
        <div className="pp-loc">
          <div className="pp-loc-photo pineapple-social">
            <span className="pp-loc-ribbon">Featured</span>
          </div>
          <div className="pp-loc-info">
            <div className="pp-loc-name">Pineapple Social <span className="pp-loc-area">East Village</span></div>
            <div className="pp-loc-meta">Avenue A · Cocktail bar</div>
            <div className="pp-loc-offer">
              <span>2 drinks + shared appetizers</span><span className="pp-loc-price">from $30/person</span>
            </div>
          </div>
        </div>
        <div className="pp-loc">
          <div className="pp-loc-photo mercer-room" />
          <div className="pp-loc-info">
            <div className="pp-loc-name">The Mercer Room <span className="pp-loc-area">Midtown</span></div>
            <div className="pp-loc-meta">Madison Ave · Cocktail lounge</div>
            <div className="pp-loc-offer">
              <span>2 drinks</span><span className="pp-loc-price">from $25/person</span>
            </div>
          </div>
        </div>
        <div className="pp-loc">
          <div className="pp-loc-photo frenchie" />
          <div className="pp-loc-info">
            <div className="pp-loc-name">Frenchie <span className="pp-loc-area">West Village</span></div>
            <div className="pp-loc-meta">Christopher St · Cocktails</div>
            <div className="pp-loc-offer">
              <span>Open bar, 90 min</span><span className="pp-loc-price">$60/head</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function ReservePreview() {
  return (
    <div className="pp-phone pp-dark">
      <div className="pp-body">
        <div className="pp-reserve-box">
          <div className="pp-line">
            <span>Thursday, May 23</span>
            <span className="mono" style={{ fontSize: 10, color: 'var(--ink-soft)' }}>5:30 PM</span>
          </div>
          <div className="pp-line">
            <span>Headcount</span>
            <span className="pp-stepper">
              <button>−</button>
              <span className="pp-stepper-val">12</span>
              <button>+</button>
            </span>
          </div>
          <div className="pp-line">
            <span className="mono" style={{ fontSize: 10, color: 'var(--ink-soft)' }}>$30 × 12</span>
            <span style={{ fontWeight: 600 }}>$360</span>
          </div>
          <div className="pp-total">
            <span className="pp-total-label">Total</span>
            <span className="pp-total-amt">$360</span>
          </div>
        </div>
        <p style={{ margin: '12px 0 0', color: 'var(--ink-soft)', fontSize: 10 }}>
          <strong style={{ color: 'var(--ink)' }}>Free cancel</strong> up to 3pm day-of.
        </p>
        <button className="pp-reserve-btn">Reserve</button>
      </div>
    </div>
  );
}

export function InvitePreview() {
  return (
    <div className="pp-phone pp-dark">
      <div className="pp-body">
        <div className="pp-group-label">Share link</div>
        <div className="pp-share-bar">
          <span className="pp-url">goaround.io/b/pineapple-may23-7m</span>
          <button className="pp-copy">Copy</button>
        </div>

        <div className="pp-group-label">Or invite by email</div>
        <div className="pp-invite-row">
          <input value="teammate@acme.com" readOnly />
          <button className="pp-invite-btn">Invite</button>
        </div>
        <div className="pp-invite-row" style={{ marginTop: 5 }}>
          <input value="" placeholder="Add another teammate" readOnly />
          <button className="pp-invite-btn ghost">+ Add</button>
        </div>

        <p style={{ margin: '14px 0 0', color: 'var(--ink-soft)', fontSize: 10 }}>
          One-click RSVP in the email. No account needed.
        </p>
      </div>
    </div>
  );
}

export function RsvpPreview() {
  return (
    <div className="pp-phone pp-dark">
      <div className="pp-body">
        <div className="pp-rsvp-summary">
          <div className="pp-rsvp-stat"><div className="n" style={{ color: 'oklch(0.82 0.16 145)' }}>9</div><div className="l">Yes</div></div>
          <div className="pp-rsvp-stat"><div className="n" style={{ color: 'oklch(0.82 0.14 70)' }}>1</div><div className="l">Maybe</div></div>
          <div className="pp-rsvp-stat"><div className="n" style={{ color: 'var(--ink-soft)' }}>0</div><div className="l">No</div></div>
          <div className="pp-rsvp-stat"><div className="n" style={{ color: 'var(--ink)' }}>2</div><div className="l">Open</div></div>
        </div>

        <Row name="Maya Chen" email="maya@acme.com" status="yes" />
        <Row name="Devin Park" email="devin@acme.com" status="yes" />
        <Row name="Sam Liu" email="sam@acme.com" status="maybe" />
        <Row name="Priya Rao" email="priya@acme.com" status="pending" />
      </div>
    </div>
  );
}

function Row({ name, email, status }: { name: string; email: string; status: 'yes' | 'maybe' | 'no' | 'pending' }) {
  const pillClass = status === 'yes' ? 'pp-pill-active' : status === 'maybe' ? 'pp-pill-pending' : 'pp-pill-cancelled';
  return (
    <div className="pp-rsvp-row">
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span className="nm">{name}</span>
        <span className="em">{email}</span>
      </div>
      <span className={`pp-pill ${pillClass}`}>{status}</span>
    </div>
  );
}
